import React from 'react';
import { useRouterState } from '@tanstack/react-router';

import { useAuthenticatedUser } from '../Auth';

import { identifyPendoAccount, identifyPendoVisitor } from './pendoVisitor';

/**
 * Boots Pendo once the authenticated user is known.
 *
 * Renders nothing — it exists so `pendo.initialize` runs inside the React tree
 * where the user query lives, rather than at module scope where it fired
 * before auth had resolved and produced an anonymous visitor.
 */
export function PendoIdentity() {
  const authenticatedUser = useAuthenticatedUser();
  const user = authenticatedUser.user;
  const subscriptionId = useRouterState({
    select: (state) => {
      return getHashQueryParam(state.location.hash, 'subscriptionId');
    },
  });

  React.useEffect(() => {
    if (!user) {
      return;
    }

    identifyPendoVisitor({
      userId: user.id,
      email: user.email,
      country: user.country,
      accountId: subscriptionId,
    });
  }, [user, subscriptionId]);

  React.useEffect(() => {
    if (!subscriptionId) {
      return;
    }

    identifyPendoAccount(subscriptionId);
  }, [subscriptionId]);

  return null;
}

function getHashQueryParam(hash: string, key: string) {
  const query = hash.split('?')[1] ?? '';
  return new URLSearchParams(query).get(key) || null;
}
